import axios_req from './axios'
import store from './store'
// const req_url = (store.state.env == 'development' ? '/api' : 'http://data-api.vcbeat.cn')
const req_url = store.state.req_url

let getDict =  (data, cb) => axios_req('post','/dg/all',{}, cb)// 获取字典
let getMapTag =  (data, cb) => axios_req('post','/dg/getmaptag',data, cb)// 根据图表id获取标签数据

let topicList =  (data, cb) => axios_req('post','/dg/list', data, cb)  //快讯列表
let topicDetail =  (data, cb) => axios_req('post','/dg/detail', data, cb)  //快讯详情
let topicLatest =  (data, cb) => axios_req('post','/dg/latest', data, cb)  //快讯新消息

// 用户
let loginOnPhone =  (data, cb) => axios_req('post','/dg/loginonphone', data, cb)// 手机登录
let checkTel =  (data, cb) => axios_req('post','/dg/checktel', data, cb)// 手机号查重
let sendCode =  (data, cb) => axios_req('post','/dg/sendcode', data, cb)// 验证码
let loginOut =  (data, cb) => axios_req('post','/dg/loginout', data, cb)// 退出登录
let loginOnWx =  (data, cb) => axios_req('post','/dg/loginonwx', data, cb)// 微信登录
let perfect =  (data, cb) => axios_req('post','/dg/perfect', data, cb)// 微信登录
let regMobile =  (data, cb) => axios_req('post','/dg/regmobile', data, cb)//  手机号注册用户、忘记密码
let checkMobileReg =  (data, cb) => axios_req('post','/dg/checkmobilereg', data, cb)//  用户注册/绑定时，检查电话号码是否被注册
let bindMobile =  (data, cb) => axios_req('post','/dg/bindMobile', data, cb)//  微信用户绑定手机号
let updateUserInfo =  (data, cb) => axios_req('post','/dg/updateuserinfo', data, cb)//  微信用户绑定手机号
let paymentList =  (data, cb) => axios_req('post','/dg/paymentlist', data, cb)//  支付记录
let noPayOrderList =  (data, cb) => axios_req('post','/dg/nopayorderlist', data, cb)//  未支付记录
let refreshUserInfo =  (data, cb) => axios_req('post','/dg/refreshuserinfo', data, cb)//  刷新用户信息
let guessLike =  (data, cb) => axios_req('post','/dg/guesslike', data, cb)//  猜你喜欢列表
let userFavorite =  (data, cb) => axios_req('post','/dg/userfavorite', data, cb)//  收藏列表
let updateUserIdentity =  (data, cb) => axios_req('post','/dg/updateuseridentity', data, cb)//  修改用户身份
let addFavorite =  (data, cb) => axios_req('post','/dg/addfavorite', data, cb)//  添加用户收藏/点赞
let delFavorite =  (data, cb) => axios_req('post','/dg/delfavorite', data, cb)//  取消用户收藏/点赞

// 关注
let editsubGroup =  (data, cb) => axios_req('post','/dg/editsubgroup', data, cb)// 添加编辑组
let subscribeList =  (data, cb) => axios_req('post','/dg/subscribelist', data, cb)// 获取关注信息
let deleteSubscribe =  (data, cb) => axios_req('post','/dg/deletesubscribe', data, cb)// 动脉橙用户取消、移除关注；删除分组
let addSubscribe =  (data, cb) => axios_req('post','/dg/addsubscribe', data, cb)// 新增用户关注，
let findEntity =  (data, cb) => axios_req('post','/dg/findentity', data, cb)// 关键词查询公司/机构
let recommend =  (data, cb) => axios_req('post','/dg/recommend', data, cb)// 推荐

// 实体
let entityDetail =  (data, cb) => axios_req('post','/dg/entitydetail', data, cb)// 详情
let entityCompare =  (data, cb) => axios_req('post','/dg/entitycompare', data, cb)// 对比
let hospitalDetail =  (data, cb) => axios_req('post','/dg/hospitaldetail', data, cb)// 医院
let hospitalTeam =  (data, cb) => axios_req('post','/dg/hospitalteam', data, cb)// 医院团队

// 人物
let peoDetail =  (data, cb) => axios_req('post','/dg/peodetail', data, cb)// 详情

// 投融资
let eventTrendTotal =  (data, cb) => axios_req('post','/dg/eventtrendtotal', data, cb)// 投融资总趋势：融资(平均)金额、事件数、轮次、地域分布图
let eventTrendTag =  (data, cb) => axios_req('post','/dg/eventtrendtag', data, cb)// 投融资总趋势：融资(平均)金额、事件数、轮次、地域分布图
let eventTop =  (data, cb) => axios_req('post','/dg/eventtop', {}, cb)// 投融资融资额top30
let orgTop =  (data, cb) => axios_req('post','/dg/orgtop', {}, cb)// 投融资投资机构top30
let faTop =  (data, cb) => axios_req('post','/dg/faorgtop', {}, cb)// 投融资fa机构top30
let eventReport =  (data, cb) => axios_req('post','/dg/eventreport', data, cb)// 投融资融资报告

// 意见反馈
let feedBack =  (data, cb) => axios_req('post','/dg/feedback', data, cb)// 意见反馈
let topicSibling =  (data, cb) => axios_req('post','/dg/topicsibling', data, cb)// 意见反馈

// 分类统计快讯数量
let topicCount =  (data, cb) => axios_req('post','/dg/topiccount', data, cb)// 分类统计快讯数量
let userEntityCount  =  (data, cb) => axios_req('post','/dg/userentitycount', data, cb)// 计算用户关注的公司/机构的数量
// 推送最新消息
let pushTopic =  (data, cb) => axios_req('post','/dg/pushtopic', data, cb)// 推送最新消息

// 专题
let recommendTheme =  (data, cb) => axios_req('post','/dg/recommendtheme', data, cb)// 推荐专题列表
let themeList =  (data, cb) => axios_req('post','/dg/themelist', data, cb)// 专题列表，除去推荐的
let themeInfo =  (data, cb) => axios_req('post','/dg/themeinfo', data, cb)// 获取动脉橙专题的基本信息+模块名
let themeModule =  (data, cb) => axios_req('post','/dg/thememodule', data, cb)// 获取专题下模块的内容
let themeNewsTopic =  (data, cb) => axios_req('post','/dg/themenewstopic', data, cb)// 获取专题下模块的内容
let advList =  (data, cb) => axios_req('post','/dg/advlist', data, cb)// 获取广告信息
let previewTheme =  (data, cb) => axios_req('post','/dg/previewtheme', data, cb)// 主题预览
let themeModulContentAll =  (data, cb) => axios_req('post','/dg/thememodulcontentall', data, cb)// 专题首次全部加载
let recommendThemeList =  (data, cb) => axios_req('post','/dg/recommendthemelist', data, cb)// 猜你喜欢专题推荐
let getMapById =  (data, cb) => axios_req('post','/dg/getmapbyid', data, cb)// 根据图谱id获取图谱数据
let getTableById =  (data, cb) => axios_req('post','/dg/gettablebyid', data, cb)// 根据图谱id获取表格数据
let createThemeTypeOrder =  (data, cb) => axios_req('post','/dg/createthemetypeorder', data, cb)// 根据图谱id获取表格数据
let createThemeTypePayUrl =  (data, cb) => axios_req('post','/dg/createthemetypepayurl', data, cb)// 根据图谱id获取表格数据
let getUserPayThemeType =  (data, cb) => axios_req('post','/dg/getuserpaythemetype', data, cb)// 根据图谱id获取表格数据
let paidThemeType =  (data, cb) => axios_req('post','/dg/paidthemetype', data, cb)// 根据图谱id获取表格数据
let tctEntityList =  (data, cb) => axios_req('post','/dg/tctentitylist', data, cb)// 专题详情--实体对比投融资列表
let policyAnnotation =  (data, cb) => axios_req('post','/dg/policyannotation', data, cb)// 政策要点列表
let getRelevantTheme =  (data, cb) => axios_req('post','/dg/getrelevanttheme', data, cb)// “猜你喜欢”列表
let getTctData =  (data, cb) => axios_req('post','/dg/gettctdata', data, cb)// 获取对比图
// 添加点击量
let addPuv =  (data, cb) => axios_req('post','/dg/addpuv', data, cb)// 添加点击量

// 简报
let customReportDetail =  (data, cb) => axios_req('post','/dg/customreportdetail', data, cb)// 简报详情接口
let chapterDetail =  (data, cb) => axios_req('post','/dg/chapterdetail', data, cb)// 简报期刊详情接口
let chapterModuleContent =  (data, cb) => axios_req('post','/dg/chaptermodulecontent', data, cb)// 简报-期刊-模块-内容
let previewReport = (data, cb) => axios_req('post','/dg/previewreport', data, cb)// 简报-期刊-模块-内容

// 数据
let compList =  (data, cb) => axios_req('post','/dg/complist', data, cb)// 公司列表
let orgList =  (data, cb) => axios_req('post','/dg/orglist', data, cb)// 机构列表
let hospitalList =  (data, cb) => axios_req('post','/dg/hospitallist', data, cb)// 医院列表
let policyList =  (data, cb) => axios_req('post','/dg/policylist', data, cb)// 政策列表
let eventList =  (data, cb) => axios_req('post','/dg/eventlist', data, cb)// 事件列表
let dataRed =  (data, cb) => axios_req('post','/dg/dataredpoint', data, cb)// 红点

// 招标采购
let biddingList =  (data, cb) => axios_req('post','/dg/biddinglist', data, cb)// 招标采购列表
let biddingDetail =  (data, cb) => axios_req('post','/dg/biddingdetail', data, cb)// 事件列表
// 公告
let noticeList =  (data, cb) => axios_req('post','/dg/noticelist', data, cb)// 事件列表
let noticeDetail =  (data, cb) => axios_req('post','/dg/noticedetail', data, cb)// 事件列表

// 招股书
let prospectusList =  (data, cb) => axios_req('post','/dg/prospectuslist', data, cb)// 招股书列表

// 产品名
let productList =  (data, cb) => axios_req('post','/dg/productlist', data, cb)// 产品名
// 会议列表
let meetingList =  (data, cb) => axios_req('post','/dg/meetinglist', data, cb)// 会议列表

// 政策
let policyDetail =  (data, cb) => axios_req('post','/dg/policydetail', data, cb)// 政策列表
let tagPolicyNum =  (data, cb) => axios_req('post','/dg/tagpolicynum', data, cb)// 政策列表

// 行业数据
let getHyData =  (data, cb) => axios_req('post','/dg/gethydata', data, cb)// 行业数据列表

// 股价信息
let stockList =  (data, cb) => axios_req('post','/dg/stocklist', data, cb)// 股价信息列表

// 上市公司财务报表
let getFinanceData =  (data, cb) => axios_req('post','/dg/getfinancedata', data, cb)// 上市公司财务报表
let getEntityFinanceData =  (data, cb) => axios_req('post','/dg/getentityfinancedata', data, cb)// 上市公司财务报表详情

// 计算
let compNum =  (data, cb) => axios_req('post','/dg/compnum', data, cb)// 计算公司数量
let orgNum =  (data, cb) => axios_req('post','/dg/orgnum', data, cb)// 计算机构数量
let hospitalNum =  (data, cb) => axios_req('post','/dg/hospitalnum', data, cb)// 计算医院数量
let policyNum =  (data, cb) => axios_req('post','/dg/policynum', data, cb)// 计算政策数量
let eventNum =  (data, cb) => axios_req('post','/dg/eventnum', data, cb)// 计算事件数量
let tagEventNum =  (data, cb) => axios_req('post','/dg/tageventnum', data, cb)// 产业领域数量计算-投融资/并购
let tagOrgNum =  (data, cb) => axios_req('post','/dg/tagorgnum', data, cb)// 产业领域数量计算-机构
let tagCompNum =  (data, cb) => axios_req('post','/dg/tagcompnum', data, cb)// 产业领域数量计算-公司
let tagTopicNum =  (data, cb) => axios_req('post','/dg/tagtopicnum', data, cb)// 产业领域数量计算-话题

// 搜索
let getHotKey =  (data, cb) => axios_req('post','/dg/gethotkey', data, cb)// 获取热词列表
let search =  (data, cb) => axios_req('post','/dg/search', data, cb)// 分类搜索动脉橙数据
let hotElement =  (data, cb) => axios_req('post','/dg/hotelement', data, cb)// 热门推荐+热词搜索

// 按需获取元数据
let getMeta =  (data, cb) => axios_req('post','/dg/getmeta', data, cb)// 分类搜索动脉橙数据


// 订单相关接口
let createVipOrder =  (data, cb) => axios_req('post','/dg/createviporder', data, cb)// 创建会员订单
let vipPayUrl =  (data, cb) => axios_req('post','/dg/vipPayUrl', data, cb)// 生成会员支付链接接口
let addInvoice =  (data, cb) => axios_req('post','/dg/addinvoice', data, cb)// 添加发票
let checkOrderPaid =  (data, cb) => axios_req('post','/dg/checkorderpaid', data, cb)// 检查订单支付状态
let createReportOrder =  (data, cb) => axios_req('post','/dg/createreportorder', data, cb)// 生成报告购买订单
let reportPayUrl =  (data, cb) => axios_req('post','/dg/reportpayurl', data, cb)// 生成报告支付链接
let orderDetail =  (data, cb) => axios_req('post','/dg/orderdetail', data, cb)// 订单详情
let invoiceTitle =  (data, cb) => axios_req('post','/dg/invoicetitle', data, cb)// 用户发票抬头记录
let cancelOrder =  (data, cb) => axios_req('post','/dg/cancelorder', data, cb)// 用户发票抬头记录

// 报告
let reportList =  (data, cb) => axios_req('post','/dg/reportlist', data, cb)// 报告列表
let reportNum =  (data, cb) => axios_req('post','/dg/reportnum', data, cb)// 计算报告数量-类型，时间，付费
let tagReportNum =  (data, cb) => axios_req('post','/dg/tagreportnum', data, cb)// 产业领域计算数量-动脉网报告
let reportDetail =  (data, cb) => axios_req('post','/dg/reportdetail', data, cb)// 报告详情
let reportFile =  (data, cb) => axios_req('post','/dg/reportfile', data, cb)// 获取报告文件
let getNumOfreadReport =  (data, cb) => axios_req('post','/dg/getnumofreadreport', data, cb)// 统计用户查看的免费报告篇数
let paidReport =  (data, cb) => axios_req('post','/dg/paidreport', data, cb)// 已购买报告
let recommendReport =  (data, cb) => axios_req('post','/dg/recommendreport', data, cb)// 推荐报告

// 活动
let forumList =  (data, cb) => axios_req('post','/dg/forumlist', data, cb)// 会议活动列表
let forumNum =  (data, cb) => axios_req('post','/dg/forumnum', data, cb)// 会议活动数量统计

let adduserapply = (data,cb) => axios_req('post','/dg/adduserapply', data, cb)// 首页收集用户信息

let couponList =  (data, cb) => axios_req('post','/dg/couponList', data, cb)//  拥有的优惠券列表
let dgxcxKjzy = (data,cb) => axios_req('post','/dgxcx/kjzy', data, cb)// 科技战役专题列表
let dgxcxkjzynew = (data,cb) => axios_req('post','/dgxcx/kjzynew', data, cb)// 科技战役专题列表
// 工作台
let myCollectionNum = (data,cb) => axios_req('post','/dg/mycollectionnum', data, cb)// 用户收藏内容数量
let getWeekEvent = (data,cb) => axios_req('post','/dg/getweekevent', data, cb)// 近6周的融资数据
let getHotele = (data,cb) => axios_req('post','/dg/gethotele', data, cb)// 近期热门
let getOrgTop = (data,cb) => axios_req('post','/dg/getorgtop', data, cb)// 明星企业
let recommendEntity = (data,cb) => axios_req('post','/dg/recommendentity', data, cb)// 推荐的公司+机构
let searchForEntity = (data,cb) => axios_req('post','/dg/searchforentity', data, cb)// 所搜企业
let userFeedData = (data,cb) => axios_req('post','/dg/userfeeddata', data, cb)// 所搜企业
let addTryApply = (data,cb) => axios_req('post','/dg/addtryapply', data, cb)// 申请试用
let addSubscribeMore = (data,cb) => axios_req('post','/dg/addsubscribemore', data, cb)
let getContentByCard = (data,cb) => axios_req('post','/dg/getcontentbycard', data, cb)// 一类卡片的内容列表
let getNewVersionInfo = (data,cb) => axios_req('post','/dg/getnewversioninfo', data, cb)// 获取推送的最新版本信息

let digitalMarket = (data,cb) => axios_req('post','/common/digitalMarket', data, cb, 2)// 数字化营销收集表单

// 首页
let getVersion = (data,cb) => axios_req('post','/dg/getversion', data, cb)// 获取推送的最新版本信息

let getStockByEntity = (data,cb) => axios_req('post','/dg/getstockbyentity', data, cb)// 实体相关的股票数据接口
// 新版研图
let trendOfEventList = (data,cb) => axios_req('post','/dg/trendofeventlist', data, cb)// 投融资总趋势列表-融资额|平均融资额|融资事件|轮次分布
let trendTagOfEventList = (data,cb) => axios_req('post','/dg/trendtagofeventlist', data, cb)// 投融资总趋势列表-领域分布
let trendCountryOfEventList = (data,cb) => axios_req('post','/dg/trendcountryofeventlist', data, cb)// 投融资总趋势列表-地区分布
let hotTagOfEventList = (data,cb) => axios_req('post','/dg/hottagofeventlist', data, cb)// 当前热点领域数据列表
let trendMapAmount = (data,cb) => axios_req('post','/dg/trendmapamount', data, cb)// 图表-总趋势-融资额|平均融资额|融资事件
let trendMapTag = (data,cb) => axios_req('post','/dg/trendmaptag', data, cb)// 图表-总趋势-领域分布
let trendMapRound = (data,cb) => axios_req('post','/dg/trendmapround', data, cb)// 图表-总趋势-轮次分布
let trendMapCountry = (data,cb) => axios_req('post','/dg/trendmapcountry', data, cb)// 图表-总趋势-地域分布
let hottagOfCountMap = (data,cb) => axios_req('post','/dg/hottagofcountmap', data, cb)// 图表-热点领域-融资事件
let hottagOfAmountMap = (data,cb) => axios_req('post','/dg/hottagofamountmap', data, cb)// 图表-热点领域-融资金额
let hottagOfRoundMap = (data,cb) => axios_req('post','/dg/hottagofroundmap', data, cb)// 图表-热点领域-融资轮次

let updateAccount = (data,cb) => axios_req('post','/dg/updateaccount', data, cb)// 报告下载信息收集

/**
 * 官网改版-查赛道
 */
let getOrgLikeTrack = (data,cb) => axios_req('post', '/AllRound/eventtop', data, cb, 2)//查赛道-机构青睐赛道
let getHotKeys = (data, cb) => axios_req('post', '/AllRound/hotkey', data, cb, 2) //查赛道-热词解读
let getIponews = (data, cb) => axios_req('post', '/AllRound/iponews', data, cb, 2) //查赛道-ipo进行时
let getBanner = (data, cb) => axios_req('post', '/common/getadvbyposid', data, cb, 2) //查赛道-广告位
let getChartData = (data, cb) => axios_req('post', '/AllRound/data', data, cb, 2) //查赛道-赛道全景图
let getActiveOrg = (data, cb) => axios_req('post', '/AllRound/activeOrg', data, cb, 2) //查赛道-活跃机构
let activetrack = (data, cb) => axios_req('post', '/AllRound/activetrack', data, cb, 2) //查赛道-活跃赛道
let recommendtrack = (data, cb) => axios_req('post', '/AllRound/recommendtrack', data, cb, 2) //查赛道 - 推荐赛道
let getNewslist = (data, cb) => axios_req('post', '/AllRound/newslist', data, cb, 2)//查赛道-赛道动态-更多
let getTrack = (data, cb) => axios_req('post', '/common/shrunk', data, cb, 2)//查赛道-赛道动态
/**
 * 官网改版-首页
 */
let indexFollow = (data, cb) => axios_req('post', '/home/index', data, cb, 2) //首页 - 文章列表
let indexReport = (data, cb) => axios_req('post', '/home/reportlist', data, cb, 2) //首页 - 文章列表
let articlelist = (data, cb) => axios_req('post', '/home/articlelist', data, cb, 2) //首页 - 文章列表
let getQualityReportList = (data, cb) => axios_req('post', '/report/getQualityReportList', data, cb, 2) //首页 - 优质报告
let indexlist = (data, cb) => axios_req('post', '/home/indexlist', data, cb, 2) //首页 - 信息流
let newstopiclist = (data, cb) => axios_req('post', '/home/newstopiclist', data, cb, 2) //首页 - 快讯live列表
let articleseries = (data, cb) => axios_req('post', '/home/articleseries', data, cb, 2) //首页 - 快讯live列表
let getReportChartList = (data, cb) => axios_req('post', '/report/getReportChartList', data, cb, 2) //首页 - 报告图表
let entityEvent = (data, cb) => axios_req('post', '/article/entity/event', data, cb, 2) //最新融资情况
let hottag = (data, cb) => axios_req('post', '/home/hottag', data, cb, 2) //首页 - 热门标签
let hotarticle = (data, cb) => axios_req('post', '/home/hotarticle', data, cb, 2) //首页 - 热点文章
let hotauthor = (data, cb) => axios_req('post', '/home/hotauthor', data, cb, 2) //首页 - 专栏作者
/**
 * 官网改版-文章列表
 */
let allArticles = (data, cb) => axios_req('post', '/home/allArticles', data, cb, 2) //文章列表
let commontag = (data, cb) => axios_req('post', '/common/hot/tag', data, cb, 2) //首页 - 热门标签
let allArticlesv2 = (data, cb) => axios_req('post', '/home/allArticles/v2', data, cb, 2) //首页 - 首页全部文章v2
/**
 * 官网改版-文章详情
 */
 let articleContent = (data, cb) => axios_req('post', '/article/content', data, cb, 2) //查询文章内容详情
 let authorRelation = (data, cb) => axios_req('post', '/article/author/relation', data, cb, 2) //文章作者相关信息
 let authorIndex = (data, cb) => axios_req('post', '/article/index', data, cb, 2) //上下条文章内容
 let articleRelation = (data, cb) => axios_req('post', '/article/relation', data, cb, 2) //相关文章推荐

/**
 * 官网改版-看报告
 */
let getReportList = (data, cb) => axios_req('post', '/report/getReportList', data, cb, 2) //报告列表
let getChartReportDetails = (data, cb) => axios_req('post', '/report/getChartReportDetails', data, cb, 2) //报告图表溯源接口
let getChartDownloadVerification = (data, cb) => axios_req('post', '/report/getChartDownloadVerification', data, cb, 2) //无水印图表下载验证

/**
 * 官网改版-关注
 */
let commonCompanyDetail = (data, cb) => axios_req('post', '/common/company/detail', data, cb, 2) //我的关注-公司详情
let commonStarOrgList = (data, cb) => axios_req('post', '/common/starorglist', data, cb, 2) //我的关注-明星机构
let switchFocusCompany = (data, cb) => axios_req('post', '/common/switchFocusCompany', data, cb, 2) //我的关注-公司（切换）-公司动态
let switchFocusTrack = (data, cb) => axios_req('post', '/common/switchFocusTrack', data, cb, 2) //我的关注-公司（切换）-相关赛道动态
/**
 * 官网改版-收藏
 */
let getXuserFavoriteAll = (data, cb) => axios_req('post', '/dg/getXuserFavoriteAll', data, cb) //我的关注-公司详情


/**
 * 官网改版-找公司
 */
let getThemetop = (data, cb) => axios_req('post', '/company/themetop/list', data, cb, 2) //找公司-早起项目发掘机
let companyDynamic = (data, cb) => axios_req('post', '/common/companyDynamic', data, cb, 2) //找公司 - 动态
let eventHotTag = (data, cb) => axios_req('post', '/company/event/top/tag', data, cb, 2) //找公司 - 融资热点\


let subscribeOverview = (data, cb) => axios_req('post', '/company/subscribe/overview', data, cb, 2) //关注一览（关注时间排序）


let addTryEnterPV = (data, cb) => axios_req('post', '/dg/addTryEnterPV', data, cb) 
let checkUserBehavior = (data, cb) => axios_req('post', '/dg/checkUserBehavior', data, cb) 
let addtryapplynew = (data, cb) => axios_req('post', '/dg/addtryapplynew', data, cb) 

let wxShare = (data, cb) => axios_req('post','/dg/shareneedinfo', data, cb) // 分享

// 活动数据库
let getActById = (data, cb) => axios_req('post','/dg/getActById', data, cb) // 新会议活动详情
let getActList = (data, cb) => axios_req('post','/dg/getActList', data, cb) // 新会议活动详情

// 直播
let onlinearticlelist = (data, cb) => axios_req('post', '/article/onlinearticlelist', data, cb, 2) //直播活动文章列表
let serieslist = (data, cb) => axios_req('post', '/article/serieslist', data, cb, 2) //直播活动文章列表

let liveList = (data, cb) => axios_req('post', '/alive/list', data, cb, 2) //直播列表
let liveurl = (data, cb) => axios_req('post', '/alive/url', data, cb, 2) 

let privatereport = (data, cb) => axios_req('post', '/dg/privatereport', data, cb) //定制周报详细信息获取接口
let privatereportentity = (data, cb) => axios_req('post','/dg/privatereportentity', data, cb)// 定制周报 - 特别关注列表
let customizedNewsTopic = (data, cb) => axios_req('post', '/newsTopic/customizedNewsTopic', data, cb, 2) 

let getFriendlyLinks = (data, cb) => axios_req('post', '/dg/link', data, cb) 
let getElderlyList = (data, cb) => axios_req('post', '/dg/elderlylist', data, cb) //药品列表
let getElderlyDetail = (data, cb) => axios_req('post', '/dg/elderlydetail', data, cb) //药品详情

let getAppMeta = (data, cb) => axios_req('post', '/api/meta/getmeta', data, cb, 3) 
let parkList = (data, cb) => axios_req('post', '/api/entity/parklist', data, cb, 3) 
let parkListCount = (data, cb) => axios_req('post', '/api/entity/parklistcount', data, cb, 3) 

let Achecksendmobliecode = (data, cb) => axios_req('post', '/api/login/checksendmobliecode', data, cb, 3)
let Alogin = (data, cb) => axios_req('post', '/api/login/login', data, cb, 3)
let Aresetpassword = (data, cb) => axios_req('post', '/api/login/resetpassword', data, cb, 3)
let AqrCodeCreateTmpTicket = (data, cb) => axios_req('post', '/wx/jsapi/wx93f12cd83e68833d/qrCodeCreateTmpTicket', data, cb, 3)
let Aaccountbinding = (data, cb) => axios_req('post', '/api/login/accountbinding', data, cb, 3)
let Aadvertisement = (data, cb) => axios_req('post', '/home/advertisement', data, cb, 3)
let Ainsertrecords = (data, cb) => axios_req('post', '/api/user/insertrecords', data, cb, 3)
let Agetappscanurl = (data, cb) => axios_req('post', '/api/login/getappscanurl', data, cb, 3)
let AsearchComp = (data, cb) => axios_req('post', '/api/entity/searchComp', data, cb, 3)
let Arefreshlogin = (data, cb) => axios_req('post', '/api/login/refreshlogin', data, cb, 3)

let getReportContent = (data, cb) => axios_req('post', '/dg/getReportContent', data, cb) 
let getCustomReportContentList = (data, cb) => axios_req('post', '/dg/getCustomReportContentList', data, cb)

let AchapterInfo = (data, cb) => axios_req('post', '/api/report/chapterInfo', data, cb, 3)
let AchapterModuleContentList = (data, cb) => axios_req('post', '/api/report/chapterModuleContentList', data, cb, 3)
let AchapterModuleList = (data, cb) => axios_req('post', '/api/report/chapterModuleList', data, cb, 3)



export  {
  wxShare,
	getDict, getMeta, getMapTag,
  topicList,topicDetail,topicLatest,
	loginOnPhone, sendCode, loginOut, loginOnWx, perfect, checkTel, regMobile, checkMobileReg, bindMobile, updateUserInfo, paymentList, noPayOrderList, refreshUserInfo, guessLike, userFavorite, updateUserIdentity, addFavorite, delFavorite,
  editsubGroup, subscribeList, deleteSubscribe, addSubscribe, findEntity, recommend,
	entityDetail, entityCompare, hospitalDetail, hospitalTeam,
	peoDetail, policyDetail, tagPolicyNum,
  eventTrendTotal, eventTrendTag, eventTop, orgTop, faTop, eventReport,
  feedBack, topicSibling,
  topicCount, userEntityCount,
  pushTopic,
  recommendTheme, themeList, themeInfo, themeModule, themeNewsTopic, advList, previewTheme, recommendThemeList, themeModulContentAll, getMapById, getTableById, createThemeTypePayUrl, createThemeTypeOrder, getUserPayThemeType, paidThemeType,
	tctEntityList, policyAnnotation, getRelevantTheme,
  addPuv,
  customReportDetail, chapterDetail, chapterModuleContent, previewReport,
  compList, orgList, hospitalList, policyList, eventList,
  compNum, orgNum, hospitalNum, policyNum, eventNum, tagEventNum, tagOrgNum, tagCompNum, tagTopicNum,
  getHotKey, search, hotElement,
	createVipOrder, vipPayUrl, addInvoice, checkOrderPaid, createReportOrder, reportPayUrl, orderDetail, invoiceTitle, cancelOrder,
  reportList, reportNum, tagReportNum, reportDetail, reportFile, getNumOfreadReport, paidReport, recommendReport,
	forumList, forumNum,
  adduserapply,
	couponList,
  dgxcxKjzy,dgxcxkjzynew,
	myCollectionNum, getWeekEvent, getHotele, getOrgTop, recommendEntity, searchForEntity, userFeedData,
  addTryApply, addSubscribeMore, getContentByCard,
  getNewVersionInfo,
  digitalMarket,
  biddingList, biddingDetail,
  noticeList, noticeDetail,
  getVersion,
  prospectusList,
  productList,
  meetingList,
  dataRed,
  getHyData, stockList, getFinanceData, getEntityFinanceData,
  getStockByEntity,
  trendOfEventList, trendTagOfEventList, trendCountryOfEventList, hotTagOfEventList,
  trendMapAmount, trendMapTag, trendMapRound, trendMapCountry, hottagOfCountMap, hottagOfAmountMap, hottagOfRoundMap,
  updateAccount,
  getOrgLikeTrack, getHotKeys, getIponews, getBanner, getChartData, getActiveOrg, activetrack, recommendtrack, getQualityReportList, getTrack,
  getNewslist, articlelist, indexlist, newstopiclist, articleseries, getReportChartList, entityEvent, hottag, hotarticle, hotauthor, 
  allArticles, commontag, allArticlesv2,
  indexFollow, indexReport,
  getReportList,getChartReportDetails,getChartDownloadVerification,
  articleContent, authorRelation, authorIndex, articleRelation,
  commonCompanyDetail, getXuserFavoriteAll, commonStarOrgList, switchFocusCompany, switchFocusTrack,
  getThemetop, companyDynamic, eventHotTag, getTctData, addTryEnterPV, checkUserBehavior, addtryapplynew,
  getActList, getActById,
  subscribeOverview,
  onlinearticlelist, serieslist, liveList, liveurl,
  privatereport, privatereportentity,customizedNewsTopic,
  getFriendlyLinks, getElderlyList, getElderlyDetail,
  getAppMeta, parkList, parkListCount,
  Achecksendmobliecode, Alogin, Aresetpassword, AqrCodeCreateTmpTicket, Aaccountbinding, 
  Aadvertisement, Ainsertrecords, Agetappscanurl, AsearchComp, Arefreshlogin, getReportContent, getCustomReportContentList,
  AchapterInfo, AchapterModuleContentList, AchapterModuleList,
}
